<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("members.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="3" md="3" class="px-2">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="
                    sessionStorage(search);
                    debounceInput();
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="2" class="px-2">
                <v-autocomplete
                  v-model="selected_flat"
                  label="Block"
                  :items="flats"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="getMembers()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="auto">
                <router-link to="/societyadmin/house/add" tag="button">
                  <v-btn class="primary">
                    <v-icon left> mdi-plus </v-icon>
                    Add Member
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="members"
            :search="search"
            :options.sync="options"
            :server-items-length="totalRecords"
            :loading="loading"
            :page.sync="page"
          >
              <template v-slot:item.profile_url="{ item }">
                <v-avatar
                  size="40"
                  v-if="item && item.profile_url != null"
                  class="mb-3 mt-3"
                >
                  <v-img
                    :src="API_BASE_URL + '/uploads/' + item.profile_url"
                    :alt="item.name"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <v-avatar
                  v-else
                  color="primary  primary--text"
                  class="white--text mb-3 mt-3"
                  size="40"
                >
                  <span class="fontsize-11 white--text">{{
                    item.name ? item.name.charAt(0) : ""
                  }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.house_number="{ item }">
                <span v-if="item.flat">{{ item.flat.name }}-</span>
                <span>{{ item.house_number }}</span>

              </template>
              <template v-slot:item.mobile_no="{ item }">
                {{ (item.country_code) }} {{ (item.mobile_no) }}
              </template>
              <template v-slot:item.last_active_time="{ item }">
                {{ getFormattedDate(item.last_active_time) }}
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="view_member"
                  title="View Member Details"
                  style="margin-left: -10px"
                  :to="'/societyadmin/house/view/' + item.id"
                >
                  <img src="@/components/icons/view.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="edit_member"
                  title="Edit Member Details"
                  :to="'/societyadmin/house/edit/' + item.id"
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_member"
                  title="Delete Member"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2">Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteHouse(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="closeDialog"> No </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("members.headers.profile_url")}`,
          value: "profile_url",
          width: "15%",
          sortable: false,
        },
        {
          text: `${this.$t("members.headers.houseNo")}`,
          value: "house_number",
          width: "15%",
        },
        {
          text: `${this.$t("members.headers.personName")}`,
          value: "name",
          width: "20%",
        },
        {
          text: `${this.$t("members.headers.ContactNo")}`,
          value: "mobile_no",
          width: "20%",
        },
        {
          text: `${this.$t("members.headers.LastActiveTime")}`,
          value: "last_active_time",
          sortable: false,
          width: "15%",
        },
        {
          text: `${this.$t("members.headers.actions")}`,
          value: "actions",
          sortable: false,
          width: "15%",
        },
        {},
      ],
      user: {},
      addPermissionDialog: false,
      members: [],
      deleteDialog: false,
      flats: [],
      selected_flat: "",
      options: {
        sortBy: ["created_at"],
      },
      totalRecords: 0,
      loading: false,
      page: 1,
    };
  },
  watch: {
    options: {
      handler() {
        this.getMembers();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getMembers() {
      this.loading = true;
      let page = this.options.page;
      let itemsPerPage = this.options.itemsPerPage;
      let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : "";
      let sortDesc =
        this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : "";
      let search = this.search ? this.search : "";

      let _self = this;
      _self.$axios
        .get(
          "societyadmin/members?society_id=" +
            _self.user.id +
            "&flat_id=" +
            _self.selected_flat +
            "&page=" +
            page +
            "&itemsPerPage=" +
            itemsPerPage +
            "&sortBy=" +
            sortBy +
            "&sortDesc=" +
            sortDesc +
            "&search=" +
            search
        )
        .then((response) => {
          this.loading = false;
          let data = response.data;
          if (data.status) {
            _self.members = data.members.data;
            _self.totalRecords = data.members.total;
            _self.page =
              data.members.page > data.members.lastPage ? 1 : data.members.page;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            if (data.type == "invalid") {
              localStorage.removeItem("user");
              _self.$router.push({ path: "/societyadmin/login" });
            }
          }
        });
    },
    deleteHouse(houseId) {
      let _self = this;

      _self.$axios
        .delete("societyadmin/members/" + houseId)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.getMembers();
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFlats() {
      let _self = this;
      _self.$axios.get("societyadmin/flats").then((response) => {
        let data = response.data;

        if (data.status) {
          let modifiedFlats = [...data.flats];
          modifiedFlats.unshift({ id: "single_house", name: "Single House" });
          _self.flats = modifiedFlats;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("house_search");
      } else {
        sessionStorage.setItem("house_search", search);
      }
    },
    debounceInput: debounce(function () {
      this.getMembers();
    }, 500),
    closeDialog() {
      this.deleteDialog = false;
    },
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    // this.getMembers();
    this.getFlats();
    this.search = sessionStorage.getItem("house_search");
  },
};
</script>
